module.exports = __webpack_public_path__ + "static/media/010-app.f5d39e8f.svg";